import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import LoadingDots from 'src/legacy/components/LoadingDots';

import Measure from 'react-measure';

import styles from './styles.module.scss';
import ImageLoader from '../../../ImageLoader';
import _ from 'lodash';

class CustomTooltipView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bounds: {
        width: 170,
        height: 190
      }
    }
  }

  render() {
    var image = null;
    var width = this.props.iconDimensions.width;
    var height = this.props.iconDimensions.height;

    var loadingPreview = this.props.preview.loading;

    if (this.props.preview.item && !loadingPreview && this.props.preview.item.pages && this.props.activePage && this.props.activePage.index) {
      var page = this.props.preview.item.pages[this.props.activePage.index - 1];
      image = _.get(page, "background.thumbnail");

      height = (_.get(page, "height") / _.get(page, "width")) * width;
      height = Math.min(height, this.props.iconDimensions.height);
    }

    var position = this.calculatePosition(this.state.bounds);

    let timeSpent = this.props.activePage.avgTimeSpent || 0;
    let minutes = this.padNumber(Math.floor(timeSpent / 60), 2);
    let seconds = this.padNumber(timeSpent % 60, 2);
    let pageNumber = this.padNumber(this.props.activePage.index, 2);

    return (
      <Measure bounds 
        onResize={(contentRect) => {
          this.setState({
            bounds: contentRect.bounds
          })
        }}>

        {({measureRef}) =>
          <div ref={measureRef}>
            <div className={cx(styles.tooltip, this.props.className)} id="page_tooltip" style={position}>
              <div className={styles.icon} style={{width: width, height: height}}>
                {loadingPreview && 
                  <LoadingDots dotSize={8}/>
                }

                {!loadingPreview && 
                  <ImageLoader 
                    src={image} 
                    imgProps={{
                      className: styles.previewIcon,
                      width: width,
                      height: height
                    }}
                    preloader={() => <LoadingDots dotSize={8}/>}
                  />
                }
              </div>
              <div className={cx(styles.metadata, "CustomTooltipView--metadata")}>
                <span className={styles.page}>#<span className={styles.numbers}>{pageNumber}</span></span>
                <span className={styles.timeSpent}>{this.props.timeSpentLabel} <span className={styles.numbers}>{`${minutes}:${seconds}`}</span></span>
              </div>
            </div>
          </div>  
        }
      </Measure>  
    );
  }

  calculatePosition(bounds){
    var { x, height, y } = this.props.activePage;
  
    return ({
      top: - bounds.height + y - 10
    });
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = '';
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join('0');
    }
    return padding + number;
  }
}

export default CustomTooltipView;